<template>
  <v-form ref="form">
    <v-row class="pb-8">
      <v-col cols="12">
        <p class="primary--text form__title mb-5">
          SOBRE O CONTATO
        </p>
      </v-col>
      <v-col cols="12" sm="8" class="pr-sm-5">
        <BaseFormInput
          v-model="userName"
          label-text="Nome do Usuário"
          disabled
        />
      </v-col>
      <v-col cols="12" sm="4">
        <BaseFormInput v-model="userProfile" label-text="Perfil" disabled />
      </v-col>
      <v-col cols="12" class="pt-4">
        <v-divider />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <p class="primary--text form__title mb-5">CARTEIRA</p>
      </v-col>
      <v-col cols="12">
        <BaseDataTable
          :headers="tableHeaders"
          :items="groups"
          show-select
          item-key="id"
          v-model="selectedGroups"
          class="groups-table base__datatable"
        >
        </BaseDataTable>
      </v-col>
    </v-row>
    <v-row class="mt-5">
      <v-col cols="12" sm="4">
        <BaseButton
          outlined
          color="secondary"
          v-html="'MIGRAR PARA OUTRO ATENDENTE'"
          class="font-weight-bold"
          width="100%"
          @click="openWalletTransferModal"
          :disabled="!selectedGroups.length"
        />
      </v-col>
    </v-row>
    <BaseFooter>
      <v-row>
        <v-spacer />
        <v-col cols="12" sm="3" class="mr-sm-5 pb-5 pb-sm-0">
          <BaseButton
            v-html="'CANCELAR'"
            class="error font-weight-bold"
            width="100%"
            @click="$emit('close-wallet')"
          />
        </v-col>
      </v-row>
    </BaseFooter>
    <WalletTransferModal
      v-model="walletTransferModal"
      :items="userOptions"
      @close="closeWalletTransferModal"
      @transfer-wallet="transferWallet"
    >
    </WalletTransferModal>
  </v-form>
</template>
<script>
import { mapActions } from "vuex";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import WalletTransferModal from "./WalletTransferModal.vue";

const tableHeaders = [
  { text: "Selecionar todos", value: "nome", sortable: false },
  { text: "Perfil", value: "relacionamento", sortable: false }
];

export default {
  name: "WalletGroupsForm",
  props: {
    groups: { type: Array },
    userName: { type: String },
    userProfile: { type: String }
  },
  mixins: [LoadingRequest],
  components: {
    WalletTransferModal
  },
  data: () => ({
    tableHeaders,
    selectedGroups: [],
    walletTransferModal: false,
    userOptions: []
  }),
  methods: {
    ...mapActions("user", ["requestUserSuggestions"]),
    async openWalletTransferModal() {
      this.userOptions = await this.withLoading(this.requestUserSuggestions());
      this.walletTransferModal = true;
    },
    closeWalletTransferModal() {
      this.walletTransferModal = false;
    },
    transferWallet(userId) {
      const payload = {
        grupos_economicos_ids: this.selectedGroups.map(group => group.id),
        novo_usuario_id: userId
      };
      this.$emit("transfer-wallet", payload);
    }
  }
};
</script>

<style lang="sass">
.groups-table
  &.v-data-table.theme--light
    thead tr th
      padding: 8px 8px
    tbody tr td
      padding: 18px 8px
  .theme--light.v-icon
    &.mdi-checkbox-marked
      color: var(--v-secondary-base)
</style>
